module.exports = __webpack_public_path__ + "static/media/2_en.5f574d56.png";